<template>
  <div>
    <ul class="nav nav-tabs main-tabs" v-if="!!alternateTabs">
      <template v-for="(tab, index) in alternateTabs" :key="'nav-tab-' + index">
        <li class="nav-item">
          <a class="nav-link" @click.prevent="goToPath(tab)" :href="tab.routePath" :class="{'active': currentPath === tab.routeName, 'disabled': tab.disabled}">{{tab.label}}</a>
        </li>
      </template>
    </ul>
    <ul class="nav nav-tabs main-tabs" v-else>
      <li class="nav-item">
        <a class="nav-link" @click="goToPage('projects')" :href="'/projects'" :class="{'active': currentPath === 'projects'}" rel="noopener">Projects</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" @click="goToPage('publications')" :href="'/publications'"
          :class="{'active': currentPath === 'publications', 'disabled': searchMeta && searchMeta.total <= 0}" rel="noopener">Publications</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" @click="goToPage('patents')" :href="'/patents'"
          :class="{'active': currentPath === 'patents', 'disabled': searchMeta && searchMeta.total <= 0}" rel="noopener">Patents</a>
      </li>
      <li class="nav-item"
        :class="{'disabled': clinicalStudyResults && clinicalStudyResults.meta && clinicalStudyResults.meta.total === 0}"
        :title="clinicalStudyResults && clinicalStudyResults.meta && clinicalStudyResults.meta.total === 0 ? 'No data found': ''">
          <a class="nav-link"
            @click="goToPage('clinicalStudies')" href
            :class="{'active': currentPath === 'clinicalStudies', 'disabled': searchMeta && searchMeta.total <= 0}" rel="noopener">Clinical Studies</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" @click="goToPage('news')"  :href="'/news'"
          :class="{'active': currentPath === 'news', 'disabled': searchMeta && searchMeta.total <= 0}" rel="noopener">News &amp; More</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'navigationTabs',
    data: function () {
        return {
          currentPath: null,
        }
    },
    props: {
        alternateTabs: {
            required: false
        }
    },
    computed: {
        ...mapGetters([
            'searchMeta',
            'clinicalStudyResults',
            'searchType',
            'selectedPerson'
        ])
    },
    mounted () {
      if (this.$router.currentRoute.value.path.indexOf('matchmaker') !== -1) {
        this.currentPath = 'matchmaker-' + this.$router.currentRoute.value.path.split('/')[3].toLowerCase();
      } else {
        this.currentPath = this.$router.currentRoute.value.path.split('/')[3];
      }

      if (!this.clinicalStudyResults && false) {
        this.$parent.getClinicalStudies(false);
      }
    },
    methods: {
        ...mapActions(
          ['updateSearchFacetCriteria']
        ),
        goToPage: function (page) {
            event.preventDefault();
            // if SearchId is not in search meta, pull from URL
            // TODO: handle if no SearchId exists
            let searchId = (this.searchMeta && this.searchMeta.search_id && !this.selectedPerson ? this.searchMeta.search_id : this.$router.currentRoute.value.params.search_id),
                path = '/search/' + searchId + '/' + page;// + '?searchMode=' + this.searchType;

            if (event.ctrlKey || event.metaKey) {
                let routeData = this.$router.resolve({path: path});
                window.open(routeData.href, '_blank');
            } else {
              // browser back/forward buttons
              this.currentPath = page.replace('/', '');
              if (this.currentPath === 'publications') {
                if (!sessionStorage.getItem('publicationPageLoaded')) {
                    window.sessionStorage.setItem('publicationPageLoaded', 'true');
                    this.$parent.logPublicationsPage();
                }
              }

              this.$nextTick(() => {
                if (this.$router.currentRoute.fullPath !== path) {
                  this.updateSearchFacetCriteria({field: 'sort_field', data: []});
                  this.updateSearchFacetCriteria({field: 'sort_order', data: []});
                  this.$router.push({
                      path: path
                  });
                }
              });
            }
        },
        goToPath: function (refTab) {
          this.currentPath = refTab.routeName;
          this.$nextTick(() => {
                this.$router.push({
                   path: refTab.routePath,
                   query: this.$route.query
                });
            });
        }
    }
}

</script>

<style lang="scss" scoped>
    @import '@/scss/variables.scss';
</style>
